import { Col, Collection, CollectionItem, Row } from "react-materialize";
import styles from "./Articles.module.scss";
import { Link } from "react-router-dom";

export const Articles = () => {
  return (
    <div className={styles.articles__wrapper}>
      <Row>
        <Col m={12} s={12}>
          <Collection>
            <CollectionItem href="#">
              <Link to="/article-psy1">Программное обеспечение Psycards</Link>
            </CollectionItem>
            <CollectionItem href="#">
              <Link to="/article-psy2">
                Психологическое консультирование как возможность решения
                внутренних проблем человека
              </Link>
            </CollectionItem>
            <CollectionItem href="#">
              <Link to="/article-psy3">
                Психологические и трансформационные игры можно проводить онлайн
                на основе виртуальных МАК (метафорические ассоциативные карты)
                PSYCards.
              </Link>
            </CollectionItem>
            <CollectionItem href="#">
              <Link to="/article-psy4">
                Получить психологическую консультацию можно онлайн на основе
                виртуальных МАК (метафорические ассоциативные карты) PSYCards.
              </Link>
            </CollectionItem>
            <CollectionItem href="#">
              <Link to="/article-psy5">
                Платформа для трансформационных игр PSYCards по самой доступной
                стоимости.
              </Link>
            </CollectionItem>
            <CollectionItem href="#">
              <Link to="/article-psy6">
                Входит в топ трансформационных игр, которые обязательно стоит
                попробовать для новой жизни.
              </Link>
            </CollectionItem>
          </Collection>
        </Col>
      </Row>
    </div>
  );
};
